
import React from "react";
import { CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

export const LoginHeader: React.FC = (): JSX.Element => {
  return (
    <CardHeader className="space-y-1">
      <CardTitle className="text-2xl text-center">Вход в систему</CardTitle>
      <CardDescription className="text-center">
        Войдите в свою учетную запись
      </CardDescription>
    </CardHeader>
  );
};
